module.exports = __webpack_public_path__ + "img/filter-file-upload.8aa7c2f7.svg";